import { CommonModule } from "@angular/common";
import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { Address } from "@shared/models/address";
import { Policy } from "@shared/models/policy";
import { Quotation } from "@shared/models/quotation";

@Component({
  selector: "app-address-mrh",
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: "./address-mrh.component.html",
})
export class AddressMrhComponent {
  @Input() colorLogo!: string;
  @Input() bgLogo!: string;
  @Input() data!: Policy | Quotation | Address;
}
